import React from "react";
import Biofouling2 from "components/app/report/other/biofouling2/Biofouling2";

function ScreenBiofouling2() {
	return <Biofouling2 />;
}

export default ScreenBiofouling2;
